<template>
  <div>
    Booking
  </div>
</template>

<script>
  export default {
    name: 'Booking',
  }
</script>

<style lang="scss scoped">

</style>
